export const lang = {
    get: (string: any, parameters?: any) => {
        switch (string) {
            case 'ITEMS_COMPLETED_DETAIL': {
                const foodCount = parameters?.[0]?.[0];
                const drinkCount = parameters?.[0]?.[1];
                const foodNames = parameters?.[1];
                const drinkNames = parameters?.[2];
                let result: string[] = [];
                if (foodCount) result.push(`Food: ${foodNames}`);
                if (drinkCount) result.push(`Drinks: ${drinkNames}`);
                return result.filter(Boolean).join('. ');
            }
            case 'ORDER_ARRIVED_SUMMARY': {
                const orderCode = parameters?.[0];
                return `Order #${orderCode} has arrived!`;
            }
            case 'TIMER_STARTED_DETAIL': {
                return `Timer started for ${parameters[0]} minute${parameters[1]}.`;
            }
            case 'NO_ORDERS_FOR_DAY': {
                return `No orders for ${parameters?.[0] || ''}.`.trim();
            }
            case 'NO_FOOD_ORDERS_FOR_DAY': {
                return `No food orders for ${parameters?.[0] || ''}.`.trim();
            }
            case 'NO_DRINK_ORDERS_FOR_DAY': {
                return `No drink orders for ${parameters?.[0] || ''}.`.trim();
            }
            default:
                return '';
        }
    },
    LOADING: 'Loading...',
    NO_ACTIVE_ORDERS_TO_SHOW: 'No active orders to show.',
    NO_DRINK_ORDERS: 'No drink orders.',
    NO_FOOD_ORDERS: 'No food orders.',
    CHECK_BACK_LATER: 'Check back later for new orders.',

    ALL_ORDERS: 'All Orders',
    WEEKLY_ORDERS: 'Weekly Orders',
    EAT_IN: 'Eat In',
    FIXED_DELIVERY: 'Fixed delivery',
    TAKEAWAY: 'Take away',
    TABLE_SERVING: 'Table',
    DELIVERY: 'Delivery',
    AI_PHONE_ORDERS: 'AI phone orders',
    AI_PREP_TIME: 'Average prep time right now',
    AI_PREP_TIME_HINT: 'This is what the AI phone agent quotes to callers.',
    AI_PREP_TIME_UNSET: 'Not set — callers hear 20–25 minutes',
    MINUTES_SHORT: 'min',
    AI_PHONE_ORDER: 'AI phone order',
    ORDERED_BY: 'Ordered by',
    CUSTOM: 'Custom',
    NO_UNITS_FOUND_FOR_THIS_USER: "No units found for this user.",
    CONTACT_ADMIN_IF_ERROR: "Please contact your administrator if you think this is an error.",
    SELECT: 'Select',
    PLEASE_ENTER_YOUR_DETAILS: 'Please enter your details',
    LOG_IN: 'Log In',
    EMAIL: 'Email',
    PASSWORD: 'Password',

    NO_ORDERS_FOUND: 'No orders found for selected methods.',




    SELECT_DELIVERY_METHODS: 'Select delivery methods',
    ALL_SERVING_METHODS: 'All serving methods',
    NO: 'No',
    YES: 'Yes',
    AND: 'and',
    REJECT: 'Reject',
    ACCEPT: 'Accept',
    ORDERS: 'orders',
    CHECK_BACK_LATER_FOR_NEW_ORDERS: 'Check back later for new orders!',
    SELECT_AT_LEAST_ONE_SERVING_METHOD: 'Select at least one serving method to show its orders.',
    COMPLETED: "Completed",
    ACTIVE: "Active",
    SCHEDULED: "Scheduled",
    INCOMING: "Incoming",
    LANGUAGE: 'Language',
    SALES_CHANNEL: 'Sales Channel',
    PHONE_LABEL: 'Phone',
    EMAIL_LABEL: 'Email',
    ORDER_NUMBER: "Order",
    BY: "By:",
    TIME: "Time:",
    ORDER_INFO: "Order Info",
    CUSTOMER_NAME: "Customer name",
    ORDER_DATE: "Order date",
    ORDERED_AT: "Ordered",
    COMPLETED_AT: "Completed",
    TABLE: "Table",
    LOCATION: "Location",
    ORDER_NOTE: "Order Note",
    DELIVERY_NOTE: "Delivery Note",
    PAYMENT: "Payment",
    RECEIPT_NUMBER: "Receipt #",
    METHOD: "Method",
    FOOD: "Food",
    DRINKS: "Drinks",
    DELIVERY_FEE: "Delivery Fee",
    DISCOUNT: "Discount",
    COUPON_DISCOUNT: "Coupon Discount",
    BONUS_VOUCHER: "Bonus Voucher",
    TOTAL: "Total",
    REQUEST_REFUND: "Request Refund",
    PRODUCTS: "Products",
    UNKNOWN: "Unknown",
    NO_ORDER_SELECTED: "No Order Selected",
    SELECT_ORDER_FROM_SIDEBAR: "Select an order from the sidebar to see its details.",

    INCOMING_ORDERS: 'Incoming Orders',
    COMPLETED_ORDERS: 'Completed Orders',
    SEARCH_ORDERS: 'Search Orders',

    KIOSK_USER: 'Kiosk User',
    POS_USER: 'POS',
    NO_INCOMING_ORDERS_TO_SHOW: 'No incoming orders to show',

    PRINT: 'Print',
    PRINT_RECEIPT: 'Print receipt',
    RECEIPT_NOT_FOUND: 'Receipt not found',
    RECEIPT_PRINT_SUCCESS: 'Receipt has been sent to printer',
    START_PREPARING: 'Start preparing',
    ALL_CAUGHT_UP: 'All caught up!',

    TOGGLE_DARK_MODE: "Toggle dark mode",
    SETTINGS: "Settings",
    CLOSE: "Close",
    WORKING: "Working",
    PRINTERS: "Printers",
    BUILT_IN_PRINTER: "Built-in printer",
    BUILT_IN_PRINTER_HINT: "This screen's own printer",
    KITCHEN: "KITCHEN",
    NOTE: "Note",
    NOTIFICATIONS: "Notifications",
    OPEN_CLOSE: "App open & close",
    FOOD_SALES: "Food sales",
    DRINKS_SALES: "Drinks sales",
    MESSAGE_WHEN_TAB_CLOSED: "Message to customer when this tab is closed",
    OPEN: "Open",
    CLOSED: "Closed",
    CLOSED_MESSAGE_PLACEHOLDER: "Closed message...",
    SAVE: "Save",
    SAVED: "Settings saved",
    SOUND_ON_BONG_NOTIFICATION: "Turn on sound notification when new bong arrives",
    SOUND_UNTIL_TAP: "Play sound until someone taps the screen",
    TEXT_OFF_ON_BONG: "Turn off text notification when new bong arrives",
    HIGHLIGHT_ON_NEW_ORDER: "Highlight screen when new bong arrives",
    AVAILABLE_PRINTERS: "Available Printers",
    MAC: "MAC:",
    NO_PRINTERS_FOUND: "No available printers found",
    CHECK_PRINTER_SETUP: "Please check your printer setup or connections and try again.",
    CHANGE_UNIT: "Change Unit",
    LOGOUT: "Logout",
    BACK_TO_LOGIN: "Back to Login",
    ITEMS_COMPLETED_HEADER: "Items Completed",
    ITEMS_COMPLETED_DETAIL: "All items in this order have been completed.",
    REJECT_ORDER_CONFIRM_MESSAGE: "Are you sure you want to reject this order? This action cannot be undone.",
    REJECT_ORDER_HEADER: "Reject Order",
    REJECTED_ORDER_SUMMARY: "Order Rejected",
    REJECTED_ORDER_DETAIL: "This order has been rejected and cannot be processed any further.",
    REJECT_ORDER_ERROR_SUMMARY: "Unable to Reject Order",
    REJECT_ORDER_ERROR_DETAIL: "An error occurred while rejecting the order. Please try again.",
    REQUEST_REFUND_CONFIRM_MESSAGE: "Are you sure you want to request a refund for this order?",
    REQUEST_REFUND_HEADER: "Request Refund",
    REFUND_REQUESTED_SUMMARY: "Refund Requested",
    REFUND_REQUESTED_DETAIL: "Your request for a refund has been submitted.",
    REQUEST_REFUND_ERROR_SUMMARY: "Unable to Request Refund",
    REQUEST_REFUND_ERROR_DETAIL: "An error occurred while requesting a refund. Please try again.",
    SET_ORDER_COMPLETED_MESSAGE: "Are you sure you want to mark this order as completed?",
    SET_ORDER_COMPLETED_HEADER: "Mark Order as Completed",
    COMPLETED_TAG: "Completed",
    ORDER_STATUS_UPDATED: "Order status has been updated successfully.",
    GENERAL_ERROR: "Something went wrong. Please try again.",
    ORDER_SAVE_ROLLBACK_DETAIL: "Your changes could not be saved and were reverted.",
    NO_PRINTERS_SELECTED: 'No printers selected',
    NO_PRINTERS_CONFIGURED: 'Go to Settings -> Printers and select from available printers.',

    DONE: "Done",
    SCREEN_ZOOM: "Screen zoom",
    ZOOM_IN: "Zoom in",
    ZOOM_OUT: "Zoom out",
    ZOOM_RESET: "Reset",
    HOLD: "Hold",
    HOLD_HINT: "Complete the order automatically when the countdown reaches zero",
    DELIVERY_PLACE: "Delivery Place",
    RESET_PASSWORD: "Reset Password",
    SEARCH: "Search",
    THIS_WEEK: "This week",
    UPCOMING_WEEK: "Upcoming week",
    DAY_LOCKED_TOOLTIP: "Can only be completed on the order's scheduled day",
    WITHOUT: "Without",
    SOMETHING_WENT_WRONG: "Something went wrong",
    PLEASE_TRY_AGAIN: "Please try again",
    INVALID_EMAIL: "Invalid email",
    EMAIL_OR_PASSWORD_NOT_CORRECT: "Email or password not correct",

    // Coursing
    COURSE_NAME_1: "Starter",
    COURSE_NAME_2: "Main course",
    COURSE_NAME_3: "Dessert",
    COURSE: "Course",
    COURSE_ADDITION: "ADDITION",
    HELD_COURSES_TITLE: "Upcoming courses",
    HELD_COURSE_WAITING: "Waiting for the waiter",
    HELD_COURSES_HINT: "Shown here until the waiter sends the course. Do not prepare yet.",
    LOAD_MORE: "Load more",
}